<template>
  <div class="contents contents--pt _back-cl01">
    <section class="Form _min-h">
      <div class="inner Form__position Form__position--lg Form--pt">
        <div class="Form__thanks_area Form__unsubscribe_thanks_area">
          <p class="Form__thanks_tx">
            退会処理が完了いたしました。<br>
            MELONをご利用いただき、ありがとうございます。
          </p>
          <p class="Form__thanks_tx">
            ぜひ、マインドフルネスはこれからも続けていただけますと幸いです。
          </p>
          <p class="Form__thanks_tx">
            また、LINEのMELON公式アカウント等のブロックは、<br class="_dsp-none--sp">
            お客様ご自身で設定をお願いいたします。
          </p>
          <p class="Form__thanks_tx">
            またのご利用を心よりお待ちしております。
          </p>
          <img class="Form__thanks_img Form__unsubscribe_thanks_img" src="assets/img/form_thanks.png" alt="退会処理が完了いたしました。">
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'UnsubscribeThanks'
}
</script>
